var _a;
export var AppointmentKind;
(function (AppointmentKind) {
    AppointmentKind["therapy"] = "THERAPY";
    AppointmentKind["minorTherapy"] = "MINOR_THERAPY";
    AppointmentKind["couplesTherapy"] = "COUPLES_THERAPY";
    AppointmentKind["initialCareNavigation"] = "INITIAL_CARE_NAVIGATION";
    AppointmentKind["followUpCareNavigation"] = "FOLLOW_UP_CARE_NAVIGATION";
    AppointmentKind["initialMedicationManagement"] = "INITIAL_MEDICATION_MANAGEMENT";
    AppointmentKind["followUpMedicationManagement"] = "FOLLOW_UP_MEDICATION_MANAGEMENT";
    AppointmentKind["coaching"] = "COACHING";
    AppointmentKind["initialMedicationManagementForMinor"] = "INITIAL_MEDICATION_MANAGEMENT_FOR_MINOR";
    AppointmentKind["followUpMedicationManagementForMinor"] = "FOLLOW_UP_MEDICATION_MANAGEMENT_FOR_MINOR";
})(AppointmentKind || (AppointmentKind = {}));
export var appointmentKindLabels = (_a = {},
    _a[AppointmentKind.therapy] = 'Individual Therapy',
    _a[AppointmentKind.minorTherapy] = 'Minor Therapy Appointment',
    _a[AppointmentKind.couplesTherapy] = 'Couples Therapy Appointment',
    _a[AppointmentKind.initialMedicationManagement] = 'Initial Physician Appointment',
    _a[AppointmentKind.followUpMedicationManagement] = 'Follow-Up Physician Appointment',
    _a[AppointmentKind.initialCareNavigation] = 'Initial Care Navigator Appointment',
    _a[AppointmentKind.followUpCareNavigation] = 'Follow-Up Care Navigator Appointment',
    _a[AppointmentKind.coaching] = 'Spring Health Coaching',
    _a[AppointmentKind.initialMedicationManagementForMinor] = 'Initial Physician Appointment for Minor',
    _a[AppointmentKind.followUpMedicationManagementForMinor] = 'Follow-Up Physician Appointment for Minor',
    _a);
// Appointment kinds that do not use compass notes
export var unopenableAppointmentKinds = [AppointmentKind.coaching];
// Appointment kinds that use kareo notes
export var kareoLinkAppointmentKinds = [
    AppointmentKind.initialMedicationManagement,
    AppointmentKind.followUpMedicationManagement,
];
// Appointment kinds that use notes that cannot be linked to
export var notAvailableAppointmentKinds = [AppointmentKind.coaching];
